import { Fragment, PropsWithChildren, useEffect } from "react";
import { useDispatch } from "react-redux";
import { useSessions } from "../../models/session";
import { AppDispatch } from "../../redux/store";
import { sessionRoute, useRouteContext } from "./RouteProvider";

interface BoardsViewProps { userUid: string, boardUid: string }

export const RouteToLatestSession = ({ ...props }: PropsWithChildren<BoardsViewProps>) => {
  const [route, setRoute] = useRouteContext();
  const [sessions, sessionsLoading, sessionsError] = useSessions(props.boardUid);

  const dispatch = useDispatch<AppDispatch>()

  useEffect(() => {
    if (sessionsLoading || sessionsError) {
      // yuck. can't dismis this modal...
      // dispatch(showModal(loadingSessionsModalData()));
      return;
    }

    // case sessions to a list of SessionData
    const sessionsList = Object.values(sessions!)

    // find the session with the most recent createdDate
    var latestSession = sessionsList[0];
    for (var i = 1; i < sessionsList.length; i++) {
      if (sessionsList[i].createdDate > latestSession.createdDate) {
        latestSession = sessionsList[i];
      }
    }

    setRoute(sessionRoute(props.boardUid, latestSession.uid))
  }, [sessions])


  return (
    <Fragment>
      {props.children}
    </Fragment>
  )
}
